module.exports = {"TXTCLI_Address":{"id":"TXTCLI_Address","defaultMessage":"Adress","flags":["TRACK"],"track":"Address"}}